<div class="modal-header">
    <h4 class="modal-title pull-left">{{ 'testperiodManager.title' | t }}</h4>
</div>
<div class="modal-body">
    @if (config) {
        <generic-list-manager [config]="config" [skipReloadConfirm]="true"> </generic-list-manager>
    }
</div>
<div class="modal-footer">
    <button class="btn btn-dark" (click)="modalRef.hide()">{{ 'testperiodManager.closeBtn' | t }}</button>
</div>
